package org.example.zone360.pages.dashboard.playerAssessment

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaEllipsisVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaPen
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getSessionSummary
import kotlinx.browser.window
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CommonDropdown
import org.example.zone360.components.CustomPagination
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.MenuDropdown
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.GetSessionSummaryData
import org.example.zone360.models.MenuModel
import org.example.zone360.models.RemoveUserSeasonPayload
import org.example.zone360.pages.dashboard.coaches.FastImage
import org.example.zone360.pages.dashboard.coaches.ImageLoadTracker
import org.example.zone360.pages.dashboard.coaches.coachesLayoutPopups.ConfirmationPopup
import org.example.zone360.theme.SitePalette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.AppGlobal.Companion.teamDataList
import org.example.zone360.utils.Divider
import org.example.zone360.utils.Res
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.extractTeamName
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.example.zone360.utils.removeUserSeason
import org.example.zone360.utils.updateUserWithTeam

@Composable
fun PlayersData(
    data: List<GetPlayerData>,
    onRecommendationClick: (GetPlayerData) -> Unit = {},
    breakpoint: Breakpoint,
    toastMessage: (String) -> Unit,
    sitePalette: SitePalette,
) {
    val scope = rememberCoroutineScope()
    val isTeamEditMap = remember { mutableStateMapOf<String, Boolean>() }
    val selectedTeamMap = remember { mutableStateMapOf<String, String>() }
    val ctx = rememberPageContext()
    var isExpanding by remember { mutableStateOf(false) }
    val sessionSummary = remember { mutableStateListOf<GetSessionSummaryData>() }
    var isLoading by remember { mutableStateOf(false) }
    var isSentLoading by remember { mutableStateOf(false) }
    var playerId by remember { mutableStateOf("") }
    var isRemoving by remember { mutableStateOf(false) }
    var removePlayer by remember { mutableStateOf(false) }

    LaunchedEffect(data) {
        val urls = data
            .filter { it.imageUrl.isNotEmpty() }
            .take(10)
            .map { "${Res.Images.base_Image_Url}${it.imageUrl}" }
        ImageLoadTracker.preload(urls)
    }
    // Add this after imageLoadStates
    if (removePlayer) {
        ConfirmationPopup(
            onDismiss = { removePlayer = false },
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            title = "Remove Player",
            message = "Are you sure you want to remove this player?",
            isLoading = isRemoving,
            onConfirm = {
                scope.launch {
                    try {
                        isRemoving = true
                        val payload = RemoveUserSeasonPayload(
                            userID = playerId,
                            seasonID = AppGlobal.selectedSeasonId,
                            organization = AppGlobal.userData.organization
                        )
                        val response = removeUserSeason(payload)
                        if (response.error.isNullOrBlank()) {
                            toastMessage(response.message ?: "")
                            showToast(ToastID.SUCCESS)
                            AppGlobal.refreshPlayerList = getCurrentMilliseconds().toString()
                            removePlayer = false
                        } else {
                            toastMessage(response.error)
                            showToast(ToastID.ERROR)
                        }

                    } catch (ce: CancellationException) {
                        throw ce
                    } catch (_: Exception) {
                        toastMessage("Failed to remove this player")
                        showToast(ToastID.ERROR)
                    } finally {
                        isRemoving = false
                    }
                }

            }
        )
    }

    val sortedPlayer by remember(data) {
        mutableStateOf(data.sortedByDescending { it.count })
    }

    val sitePalette = ColorMode.current.toSitePalette()
    if (breakpoint >= Breakpoint.MD) {
        sortedPlayer.forEachIndexed { _, player ->

            val isTeamEdit = isTeamEditMap[player.userId] ?: false
            val selectedTeam = selectedTeamMap[player.userId]
                ?: player.teams.firstOrNull { team ->
                    if (AppGlobal.selectedSeasonId.isEmpty()) {
                        team.seasonID.contains("default", ignoreCase = true)
                    } else {
                        team.seasonID == AppGlobal.selectedSeasonId
                    }
                }?.teamID?.extractTeamName()
                ?: "-"
            Row(
                modifier = Modifier.fillMaxWidth()
                    .margin(topBottom = 10.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Row(
                    modifier = Modifier.width(130.px)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            ctx.router.navigateTo("/player-details?userId=${player.userId}")
                        },
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (player.imageUrl.isNotEmpty()) {
                        FastImage(
                            url = "${Res.Images.base_Image_Url}${player.imageUrl}",
                            size = 30,
                            modifier = Modifier.margin(right = 7.px)
                        )
                    } else {
                        Image(
                            src = Res.Images.userIcon,
                            modifier = Modifier.size(30.px)
                                .margin(right = 7.px)
                                .borderRadius(100.px)
                        )
                    }
                    FieldTitleTextNormalSimple(
                        text = "${player.firstName} ${player.lastName}".ifEmpty { "-" }
                            .split(" ")
                            .joinToString(" ") { word ->
                                word.lowercase().replaceFirstChar { it.titlecase() }
                            },
                        isClickable = true,
                        wordBreak = WordBreak.Normal,
                        overflowWrap = OverflowWrap.BreakWord,
                        width = if (window.screen.width in 800..1600) 80.px else 100.px,
                    )
                }
                FieldTitleTextNormalSimple(
                    text = player.count.toString(),
                    width = 120.px,
                    textAlign = TextAlign.Center
                )
                FieldTitleTextNormalSimple(
                    text = player.mentions.ifEmpty { "-" },
                    width = 100.px,
                    textAlign = TextAlign.Center
                )
                FieldTitleTextNormalSimple(
                    text = player.coachName.ifEmpty { "-" }.replaceFirstChar {
                        if (it.isLowerCase()) it.titlecase() else it.toString()
                    },
                    width = 120.px,

                    textAlign = TextAlign.Center,
//                    wordBreak = WordBreak.BreakAll
                )
                Row(
                    modifier = Modifier.width(160.px).gap(2.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (isTeamEdit) {
                        Box(Modifier.fillMaxHeight()) {
                            CommonDropdown(
                                data = teamDataList.map { it.teamName },
                                onSelect = { newTeam ->
                                    selectedTeamMap[player.userId] = newTeam.extractTeamName()
                                    val teamId =
                                        teamDataList.find { it.teamName == newTeam }?.id ?: newTeam
                                    scope.launch {
                                        try {
                                            val response = updateUserWithTeam(
                                                teamName = teamId,
                                                userID = player.userId,
                                                organization = AppGlobal.userData.organization,
                                                isRemove = false
                                            )
                                            if (response.data == "Team updated successfully!") {
                                                val playerIndex = sortedPlayer.indexOf(player)
                                                sortedPlayer[playerIndex].team = newTeam
                                            }

                                        } catch (_: Exception) {
                                            toastMessage("Failed to add team")
                                            showToast(ToastID.ERROR)

                                        } finally {
                                            isTeamEditMap[player.userId] =
                                                !(isTeamEditMap[player.userId] ?: false)

                                        }
                                    }
                                },
                                selectedItem = selectedTeam,
                                width = 100.px,
                                leftRightPadding = 5.px

                            )

                        }
                        CustomSpacer(10.px)
                    } else {
                        FieldTitleTextNormalSimple(
                            text = selectedTeam,
                            width = 100.px,
                            textAlign = TextAlign.Center
                        )
                    }
                    FaPen(
                        size = IconSize.XXS,
                        modifier = Modifier.onClick {
                            isTeamEditMap[player.userId] = !(isTeamEditMap[player.userId] ?: false)
                        }
                            .cursor(Cursor.Pointer))
                }
                Box(
                    modifier = Modifier.width(310.px),
                    contentAlignment = Alignment.Center
                ) {
                    Box(
                        modifier = Modifier.maxWidth(305.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Box(
                            modifier = Modifier
//                            .padding(topBottom = 5.px)
                                .borderRadius(4.px)
                                .padding(10.px)
                                .backgroundColor(sitePalette.viewButtonBackground.rgb)
                                .onClick {
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = player.email,
                                textAlign = TextAlign.Center,
                                color = sitePalette.viewText.rgb,
                                wordBreak = WordBreak.BreakAll
                            )
                        }
                    }
                }
                Box(
                    modifier = Modifier.width(130.px),
                    contentAlignment = Alignment.Center
                ) {
                    CommonButton(
                        text = "View",
                        textSpanColor = if (player.count > 0) sitePalette.viewText.rgb else sitePalette.commonButtonSupportiveTextColor.rgb,
                        backgroundColor = if (player.count > 0) sitePalette.viewButtonBackground.rgb else sitePalette.textFieldBorderColorDisabled.rgb,
                        pointerCursor = player.count > 0,
                        width = 64.px,
                        height = 28.px,
                        onCLick = {
                            if (player.count > 0) {
                                onRecommendationClick(player)
                            }
                        }
                    )
                }
                if (AppGlobal.selectedSeasonId.isNotEmpty()) {
                    Box(
                        modifier = Modifier.width(55.px),
                        contentAlignment = Alignment.Center
                    ) {
                        MenuDropdown(
                            icon = {
                                FaEllipsisVertical(
                                    modifier = Modifier.width(15.px).height(10.px)
                                        .padding(left = 11.px).margin(bottom = 2.px)
                                        .color(sitePalette.textFieldTextColor.rgb)
                                )
                            },
                            data = listOf(
                                MenuModel(text = "Remove Player from season", route = "")
                            ),
                            onSelect = {

                                if (it == "Remove Player from season") {
                                    if (player.count <= 0) {
                                        playerId = player.userId
                                        removePlayer = true
                                    } else {
                                        toastMessage("Cannot delete player with existing assessments")
                                        showToast(ToastID.ERROR)

                                    }
                                }

                            }
                        )
                    }
                }

            }
            Divider()
        }
    } else {

        var currentPage by remember { mutableStateOf(0) }
        val sessionsPerPage = 1
        val totalPages = (sortedPlayer.size + sessionsPerPage - 1) / sessionsPerPage
        val player = sortedPlayer[currentPage]
        key(player.userId) {
            val isTeamEdit = isTeamEditMap[player.userId] ?: false
            val selectedTeam = selectedTeamMap[player.userId]
                ?: player.teams.firstOrNull { team ->
                    if (AppGlobal.selectedSeasonId.isEmpty()) {
                        team.seasonID.contains("default", ignoreCase = true)
                    } else {
                        team.seasonID == AppGlobal.selectedSeasonId
                    }
                }?.teamID?.extractTeamName()
                ?: "-"
            LaunchedEffect(isExpanding) {
                if (isExpanding) {
                    isLoading = true
                    try {
                        val sessionUser = getSessionSummary(
                            userID = player.userId,
                            domainType = "soccer",
                            language = "en",
                            getAll = true,
                            isPlayer = true,
                            sessionType = "player assessment",
                            organization = AppGlobal.userData.organization
                        )
                        sessionSummary.clear()
                        sessionSummary.addAll(sessionUser.data)
                    } catch (_: Exception) {
                        toastMessage("Failed to fetch data")
                        showToast(ToastID.ERROR)
                    } finally {
                        isLoading = false
                    }
                }
            }
            Column(modifier = Modifier.fillMaxWidth().margin(top = 10.px)) {
                Column(
                    modifier = Modifier.fillMaxWidth()
                        .onClick {
                            ctx.router.navigateTo("/player-details?userId=${player.userId}")
                        }) {
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Name",
                            fontSize = 15.px,
                            fontWeight = 550,
                            width = 40.percent
                        )
                        Row(
                            modifier = Modifier.width(60.percent),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            if (player.imageUrl.isNotEmpty()) {
                                FastImage(
                                    url = "${Res.Images.base_Image_Url}${player.imageUrl}",
                                    size = 30,
                                    modifier = Modifier.margin(right = 7.px)
                                )
                            } else {
                                Image(
                                    src = Res.Images.userIcon,
                                    modifier = Modifier.size(30.px)
                                        .margin(right = 7.px)
                                        .borderRadius(100.px)
                                )
                            }
                            FieldTitleTextNormalSimple(
                                text = "${player.firstName} ${player.lastName}".ifEmpty { "-" }
                                    .split(" ")
                                    .joinToString(" ") { word ->
                                        word.lowercase().replaceFirstChar { it.titlecase() }
                                    },
                                wordBreak = WordBreak.Normal,
                                overflowWrap = OverflowWrap.BreakWord,
                                isClickable = true
                            )
                        }
                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Assessments:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = 40.percent
                        )
                        FieldTitleTextNormalSimple(
                            text = player.count.toString(),
                            width = 60.percent,
                            fontSize = 15.px,
                            marginLeft = 60.px,

                            )
                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Mentions/Tags:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = 40.percent
                        )
                        FieldTitleTextNormalSimple(
                            text = player.mentions.ifEmpty { "-" },
                            width = 60.percent,
                            fontSize = 15.px,
                            marginLeft = 60.px,

                            )
                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Coach:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = 40.percent
                        )
                        FieldTitleTextNormalSimple(
                            text = player.coachName.ifEmpty { "-" }.replaceFirstChar {
                                if (it.isLowerCase()) it.titlecase() else it.toString()
                            },
                            width = 60.percent,
                            fontSize = 15.px,
                            marginLeft = 60.px,

                            )
                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Team:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = 40.percent
                        )
                        Row(
                            modifier = Modifier.width(60.percent).gap(2.px),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            if (isTeamEdit) {
                                Box(Modifier.fillMaxHeight().fillMaxWidth()) {
                                    CommonDropdown(
                                        data = teamDataList.map { it.teamName },
                                        onSelect = { newTeam ->
                                            selectedTeamMap[player.userId] =
                                                newTeam.extractTeamName()
                                            val teamId =
                                                teamDataList.find { it.teamName == newTeam }?.id
                                                    ?: newTeam
                                            scope.launch {
                                                try {
                                                    val response = updateUserWithTeam(
                                                        teamName = teamId,
                                                        userID = player.userId,
                                                        organization = AppGlobal.userData.organization,
                                                        isRemove = false
                                                    )
                                                    if (response.data == "Team updated successfully!") {
                                                        val playerIndex =
                                                            sortedPlayer.indexOf(player)
                                                        sortedPlayer[playerIndex].team = newTeam
                                                        isTeamEditMap[player.userId] =
                                                            !(isTeamEditMap[player.userId] ?: false)

                                                    }
                                                } catch (_: Exception) {
                                                    toastMessage("Failed to add team")
                                                    showToast(ToastID.ERROR)

                                                } finally {
                                                    isTeamEditMap[player.userId] =
                                                        !(isTeamEditMap[player.userId] ?: false)
                                                }
                                            }
                                        },
                                        selectedItem = selectedTeam,
                                        width = 90.percent,
                                        leftRightPadding = 5.px
                                    )

                                }
                                CustomSpacer(10.px)
                            } else {
                                FieldTitleTextNormalSimple(
                                    text = selectedTeam,
                                    width = 90.percent,
                                    marginLeft = 35.px
                                )
                            }
                            FaPen(
                                size = IconSize.XXS,
                                modifier = Modifier.onClick { event ->
                                    event.nativeEvent.stopPropagation()
                                    isTeamEditMap[player.userId] =
                                        !(isTeamEditMap[player.userId] ?: false)
                                }
                                    .cursor(Cursor.Pointer))
                        }
                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Email:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = 40.percent
                        )
                        Box(
                            modifier = Modifier.width(60.percent),
                            contentAlignment = Alignment.Center
                        ) {
                            Box(
                                modifier = Modifier.maxWidth(99.5.percent),
                                contentAlignment = Alignment.Center
                            ) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .borderRadius(4.px)
                                        .padding(10.px)
                                        .backgroundColor(sitePalette.viewButtonBackground.rgb)
                                        .onClick {
                                        },
                                    contentAlignment = Alignment.Center
                                ) {
                                    FieldTitleTextNormalSimple(
                                        text = player.email,
                                        textAlign = TextAlign.Center,
                                        color = sitePalette.viewText.rgb,
                                        width = 100.percent,
                                        wordBreak = WordBreak.BreakAll

                                    )
                                }
                            }
                        }
                    }
                }
                Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                    FieldTitleTextNormalSimple(
                        text = "Recommendations:",
                        fontSize = 15.px,
                        fontWeight = 500,
                        width = 40.percent,
                        textAlign = TextAlign.Center
                    )
                    Box(
                        modifier = Modifier.width(60.percent),
                        contentAlignment = Alignment.Center
                    ) {
                        CommonButton(
                            text = "View",
                            textSpanColor = if (player.count > 0) sitePalette.viewText.rgb else sitePalette.commonButtonSupportiveTextColor.rgb,
                            backgroundColor = if (player.count > 0) sitePalette.viewButtonBackground.rgb else sitePalette.textFieldBorderColorDisabled.rgb,
                            pointerCursor = player.count > 0,
                            width = 64.px,
                            height = 28.px,
                            onCLick = {
                                if (player.count > 0) {
                                    onRecommendationClick(player)
                                }
                            }
                        )
                    }

                }
                if (AppGlobal.selectedSeasonId.isNotEmpty()) {
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Action:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = 40.percent,
                        )
                        Box(
                            modifier = Modifier.width(60.percent),
                            contentAlignment = Alignment.Center
                        ) {
                            Box(
                                modifier = Modifier.width(55.px),
                                contentAlignment = Alignment.Center
                            ) {
                                MenuDropdown(
                                    icon = {
                                        FaEllipsisVertical(
                                            modifier = Modifier.width(15.px).height(10.px)
                                                .padding(left = 11.px).margin(bottom = 2.px)
                                                .color(sitePalette.textFieldTextColor.rgb)
                                        )
                                    },
                                    data = listOf(
                                        MenuModel(text = "Remove Player from season", route = "")
                                    ),
                                    onSelect = {

                                        if (it == "Remove Player from season") {
                                            if (player.count <= 0) {
                                                playerId = player.userId
                                                removePlayer = true
                                            } else {
                                                toastMessage("Cannot delete player with existing assessments")
                                                showToast(ToastID.ERROR)

                                            }
                                        }

                                    }
                                )
                            }

                        }
                    }
                }

                if (totalPages > 1) {
                    Column(modifier = Modifier.fillMaxWidth()) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.End
                        ) {
                            CustomPagination(
                                currentPage = currentPage,
                                totalPages = totalPages,
                                onPageChange = { newPage -> currentPage = newPage },
                                sitePalette = sitePalette,
                                leftRightPadding = 0.px,
                                topBottomPadding = 0.px
                            )
                        }
                    }

                }
            }
        }
    }
}